module.exports = __webpack_public_path__ + "static/media/back.10e8b471.svg";